import React, {Component} from "react"
import { Container } from "semantic-ui-react"
import shop from "shop/shop"
import WordPress from "../WordPress"

import "./CmsPage.css"

export default class PostPage extends Component {
  constructor(props) {
    let { params } = props.match
    console.log( `params`, props )
    super()
    this.state = {
      slug: params.slug,
      page: {}
    }
    this.load( this.state.slug )
  }

  componentWillReceiveProps(props) {
    if ( this.state.slug !== props.match.params.slug ) {
      this.setState( { slug: props.match.params.slug } )
      this.load( props.match.params.slug )
    }
  }

  load(slug) {
    console.log( `loading::slug` )
    shop.post( slug )
      .then( pages => pages[ 0 ] )
      .then( page => {
        this.setState( { page } )
        console.log( `page::loaded`, page )
      } )
  }

  render() {
    let { page } = this.state
    return (
      <Container className="pt4 cms-page">
        <WordPress page={page}/>
      </Container>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/PostPage.js